/** Výčet názvů komponent, které je možné přes custom modul přepsat */
export enum ReplaceableComponentNames {
    MenuPanelComponent = "MenuPanelComponent",
    SubmenuListComponent = "SubmenuListComponent",
    UserMenuComponent = "UserMenuComponent",
    FormMenuComponent = "FormMenuComponent",
    NotificationListComponent = "NotificationListComponent",
    QuickAccessMenuComponent = "QuickAccessMenuComponent",
}
